import React, { useState } from 'react';
import { useTagSuggestions } from '../../hooks/useTags';
import { MsComboBox } from '../MsComboBox';

interface TagRef { id: string; name: string; color: string; }

interface Props {
  id?: string;
  projectId: string;
  selected: TagRef[];
  onChange: (tags: TagRef[]) => void;
  disabled?: boolean;
}

export function TagRelationshipPicker({ id, projectId, selected, onChange, disabled }: Props) {
  const [query, setQuery] = useState('');
  const { data: suggestions = [] } = useTagSuggestions(projectId, query);

  return (
    <MsComboBox<TagRef>
      id={id}
      selected={selected}
      suggestions={suggestions}
      onChange={disabled ? () => {} : onChange}
      onQueryChange={setQuery}
      getKey={t => t.id}
      getLabel={t => t.name}
      getColor={t => t.color}
      icon="fa-circle"
    />
  );
}
